module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/homepage/join-r-8737d4d225e2dcaf87449205bdeddc5c.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/homepage/join-r.svg
// module id = jU7U
// module chunks = 9